import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import styles from './styles'
import { chainDecorators, memoized } from '../../utils/ReactUtils'

const decorators = [
  memoized,
]

function VideoGatsby(props) {
  const { src, className, ...rest } = props

  return (
    <div>
      <video {...rest} className={classNames('video', className)} src={src} />
      <style jsx>{styles}</style>
    </div>
  )
}

VideoGatsby.propTypes = {
  className: PropTypes.string,
  src: PropTypes.oneOfType([PropTypes.string]).isRequired,
}

VideoGatsby.defaultProps = {
  className: null,
  src: null,
}

VideoGatsby = chainDecorators(decorators, VideoGatsby)

export default VideoGatsby
